import React from 'react';
import PropTypes from 'prop-types';
import Compressor from '../assets/components/Compressor';
import Ventilator from '../assets/components/Ventilator';
import Defrost from '../assets/components/Defrost';
import Heater from '../assets/components/Heater';
import Status from '../status';
import {
  TYPE_COMPRESSOR,
  TYPE_VENTILATOR,
  TYPE_DEFROST,
  TYPE_HEATER,
} from '../constants';
import { colorsModeUI } from '../modeUI';
import './index.css';

/**
 * Status buttons
 * display a list of static status buttons (without onClick event) in dark or light mode
 * Parameters (Props):
 * @param array buttons = [{ disable, active, tooltip, label}]
 * @param string size = [small, medium, large]
 * @param string title
 * @param string type = [TYPE_COMPRESSOR, TYPE_VENTILATOR]
 * @param string mode = [MODE_DARK, MODE_LIGHT]
 */
export default class StatusButtons extends React.PureComponent {
  render() {
    const { buttons, size, title, type, mode } = this.props;
    const colors = colorsModeUI(mode);
    const styleBox = { backgroundColor: 'none' };
    const styleLabel = { color: colors.SECONDARY_COLOR };
    const styleTitle = { color: colors.SECONDARY_COLOR };
    return (
      <div className="container-status-buttons">
        {title && (
          <div className="title" style={styleTitle}>
            {title}
          </div>
        )}
        <div className="status-buttons">
          {buttons.map((button, index) => {
            const disable =
              button.disable !== undefined ? !!button.disable : false;
            const styleImage = { fill: colors.SECONDARY_COLOR };
            if (disable) {
              styleImage.opacity = 0.2;
            } else if (!button.active) {
              styleImage.opacity = 0.3;
            }
            let imageSVG;
            switch (type) {
              case TYPE_COMPRESSOR:
                imageSVG = (
                  <Compressor
                    className={`image ${size}`}
                    style={{
                      ...styleImage,
                      ...(!button.active || disable
                        ? { transform: 'none' }
                        : {}),
                    }}
                    id="compressor"
                  />
                );
                break;
              case TYPE_VENTILATOR:
                imageSVG = (
                  <Ventilator
                    className={`image ${size}`}
                    style={{
                      ...styleImage,
                      ...(!button.active || disable
                        ? { transform: 'none' }
                        : {}),
                    }}
                    id="ventilator"
                  />
                );
                break;
              case TYPE_DEFROST:
                imageSVG = (
                  <Defrost
                    className={`image ${size}`}
                    style={{
                      ...styleImage,
                      ...(!button.active || disable
                        ? { transform: 'none' }
                        : {}),
                    }}
                    id="defrost"
                  />
                );
                break;
              case TYPE_HEATER:
                imageSVG = (
                  <Heater
                    className={`image ${size}`}
                    style={{
                      ...styleImage,
                      ...(!button.active || disable
                        ? { transform: 'none' }
                        : {}),
                    }}
                    id="heater"
                  />
                );
                break;
              default:
            }
            return (
              <div key={index.toString()} className="button">
                <div className="label" style={styleLabel}>
                  {button.label}
                </div>
                <Status
                  disable={!button.active || disable}
                  svgImage={imageSVG}
                  size={size}
                  stylesBox={styleBox}
                  tooltip={button.tooltip}
                />
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

StatusButtons.propTypes = {
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      disable: PropTypes.bool,
      active: PropTypes.bool,
      tooltip: PropTypes.string,
      label: PropTypes.string,
    })
  ).isRequired,
  size: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.string.isRequired,
  mode: PropTypes.string,
};

StatusButtons.defaultProps = {
  size: 'medium',
  title: null,
  mode: null,
};
